import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useEffect, useState } from "react";

const Pagination = ({
	currentPage,
	totalPages,
	handlePageClick,
}: {
	dataLength: number;
	totalItems: number;
	currentPage: number;
	totalPages: number;
	handlePageClick: (page: number) => void;
}) => {
	const [gotoPage, setGotoPage] = useState(currentPage);

	useEffect(() => {
		if (!gotoPage) return;
		if (gotoPage >= 1 && gotoPage <= totalPages) {
			handlePageClick(gotoPage);
		} else {
			setGotoPage(currentPage);
		}
	}, [gotoPage]);

	const getPageNumbers = () => {
		if (totalPages <= 8) {
			return Array.from({ length: totalPages }, (_, i) => i + 1);
		}

		const pages = new Set<number>();
		pages.add(1);
		pages.add(2);
		pages.add(totalPages - 1);
		pages.add(totalPages);
		pages.add(currentPage);
		pages.add(currentPage - 1);
		pages.add(currentPage + 1);

		return Array.from(pages)
			.filter((page) => page >= 1 && page <= totalPages)
			.sort((a, b) => a - b);
	};

	return (
		<div>
			<div className="flex flex-warp flex-row items-center justify-end  w-full gap-4 mt-3 text-lg">


				{/* Pagination buttons */}
				<div className="flex items-center space-x-2">
					<button
						onClick={() => handlePageClick(currentPage - 1)}
						disabled={currentPage === 1}
						className={`p-2 rounded-full transition duration-300 ${currentPage === 1
							? "text-gray-400 cursor-not-allowed"
							: "hover:bg-gray-200"
							}`}
					>
						<FaChevronLeft size={14} />
					</button>

					{getPageNumbers().map((page, index, arr) => (
						<div key={index} className="flex">
							{index > 0 && page !== arr[index - 1] + 1 && (
								<span key={`dots-${index}`}>...</span>
							)}
							<button
								key={index}
								onClick={() => handlePageClick(page)}
								className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition duration-300 ${currentPage === page ? "bg-[#DDDDDD]" : "hover:bg-gray-200"
									}`}
							>
								{page}
							</button>
						</div>
					))}

					<button
						onClick={() => handlePageClick(currentPage + 1)}
						disabled={currentPage === totalPages}
						className={`p-2 rounded-full transition duration-300 ${currentPage === totalPages
							? "text-gray-400 cursor-not-allowed"
							: "hover:bg-gray-200"
							}`}
					>
						<FaChevronRight size={14} />
					</button>
				</div>

			</div>
		</div>
	);
};

export default Pagination;
